import { useInviteToken } from 'flows/core/components/onboarding/common/hooks';
import { useUserAndInviteInfoQuery } from '@updater/consumer-graph';
import { useSession } from '@updater/auth';

/*
 * Because this query requires us forcing a default token if nothing is provided
 * we've centralized the call here.
 *
 * The query is skipped when there is no authenticated session and no invite token,
 * since both getUser (requires auth) and inviteByToken (requires a valid token)
 * would fail. This prevents spurious GraphQL errors in guest/unauthenticated flows.
 */
export const useUserAndInviteInfo = () => {
  const token = useInviteToken();
  const { session } = useSession();

  return useUserAndInviteInfoQuery({
    variables: {
      // Currently a token must be provided so we provide a fake and searchable token
      token: token ?? 'no_token_consumer_app',
    },
    errorPolicy: 'all',
    skip: !session && !token,
  });
};
